import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { TrInputsModule } from '../tr-forms-inputs/tr-forms-inputs.module';
import { ReactiveFormsModule } from '@angular/forms';
import { TrSpinnerButtonDirectiveModule } from '../../directives';
import { HubAuthorizationComponent } from './hub-authorization.component';
import { TrDocModule } from '../tr-forms-inputs/tr-doc/tr-doc.module';
import { TrCheckboxModule } from '../tr-forms-inputs/tr-checkbox/tr-checkbox.module';
import { HubAuthorizationHeaderModule } from './components/header/hub-authorization-header.module';
import { DownloadAppModule } from './components/download-app/download-app.module';
import { ValidateTokenModule } from './components/validate-token/validate-token.module';
import { PhoneHelpModule } from './components/phone-help/phone-help.module';
import { UsingTokenToroModule } from './components/using-token-toro/using-token-toro.module';

@NgModule({
    imports: [
        CommonModule,
        SvgIconModule,
        TrInputsModule,
        ReactiveFormsModule,
        TrSpinnerButtonDirectiveModule,
        TrDocModule,
        TrCheckboxModule,
        HubAuthorizationHeaderModule,
        DownloadAppModule,
        ValidateTokenModule,
        PhoneHelpModule,
        UsingTokenToroModule,
    ],
    exports: [HubAuthorizationComponent],
    declarations: [HubAuthorizationComponent],
    entryComponents: [HubAuthorizationComponent],
})
export class HubAuthorizationModule { }
